$(document).ready(function () {
  // collection new item
  let arrNewItems = [];
  $(".new-items .collection__items ul").each(function () {
    let bestCatelogyName = $(this).attr("data-catelogy");
    arrNewItems.push(bestCatelogyName);
  });

  // append array to elem
  $.each(arrNewItems, function (index, value) {
    let newItemVal = null;
    if (index == 0) {
      newItemVal = $(
        `<li class='active' data-catelogy='${value}'> <button>${value}</button></li>`
      );
    } else {
      newItemVal = $(
        `<li data-catelogy='${value}'> <button>${value}</button></li>`
      );
    }
    $("#NewItems").append(newItemVal);
  });

  // collection best seller item
  let arrBestSeller = [];
  $(".best-seller .collection__items ul").each(function () {
    let bestCatelogyName = $(this).attr("data-catelogy");
    arrBestSeller.push(bestCatelogyName);
  });

  // append array to elem
  $.each(arrBestSeller, function (index, value) {
    let bestSellerVal = null;
    if (index == 0) {
      bestSellerVal = $(
        `<li class='active' data-catelogy='${value}'> <button>${value}</button></li>`
      );
    } else {
      bestSellerVal = $(
        `<li data-catelogy='${value}'> <button>${value}</button></li>`
      );
    }
    $("#bestSellers").append(bestSellerVal);
  });

  // tag new item collection select
  $("#NewItems li button").on("click", function () {
    $("#NewItems li, .new-items .home-collection-grid").removeClass("active");
    let dataCategory = $(this).parent("li").data("catelogy");
    $(this).parent("li").addClass("active");
    $(
      '.new-items .home-collection-grid[data-catelogy="' + dataCategory + '"]'
    ).addClass("active");
  });

  // tag new item collection select
  $("#bestSellers li button").on("click", function () {
    $("#bestSellers li, .best-seller .home-collection-grid").removeClass(
      "active"
    );
    let dataCategory = $(this).parent("li").data("catelogy");
    $(this).parent("li").addClass("active");
    $(
      '.best-seller .home-collection-grid[data-catelogy="' + dataCategory + '"]'
    ).addClass("active");
  });

  // top banner
  if ($(".banner-slick-slider").length) {
    $(".banner-slick-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: '<a href="javascript:void(0)" class="arr-right"></a>',
      prevArrow: '<a href="javascript:void(0)" class="arr-left"></a>',
      dots: true,
    });
  }

  // product slider

  let productSlider = $(".product__media-list");
  if (productSlider.length) {
    $(".product__media-list").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      infinite: true,
      asNavFor: ".thumbnail-list",
    });
    $(".thumbnail-list").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: ".product__media-list",
      dots: true,
      // centerMode: true,
      focusOnSelect: true,
      infinite: true,
    });
  }

  // Featured collection slider
  if ($(window).innerWidth() >= 1023) {
    if ($(".featured-collection-slider").length) {
      $(".featured-collection-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        nextArrow:
          '<a href="javascript:void(0)" class="ftr-arr-right"><img src="https://southern-group-sgp.myshopify.com/cdn/shop/t/1/assets/arrow-right.svg" class="img-fluid" alt=""></a>',
        prevArrow:
          '<a href="javascript:void(0)" class="ftr-arr-left"><img src="https://southern-group-sgp.myshopify.com/cdn/shop/t/1/assets/arrow-left.svg" class="img-fluid" alt=""></a>',
      });
    }

    // You may also like
    let checkAlsoLike = false;
    function initializeRecommendationSlider() {
      let checkAlsoLikeElm = $("body").find(".recommendation-slider");
      if (checkAlsoLikeElm.length > 0 && !checkAlsoLike) {
        $(".recommendation-slider").slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          nextArrow:
            '<a href="javascript:void(0)" class="ftr-arr-right"><img src="https://southern-group-sgp.myshopify.com/cdn/shop/t/1/assets/arrow-right.svg" class="img-fluid" alt=""></a>',
          prevArrow:
            '<a href="javascript:void(0)" class="ftr-arr-left"><img src="https://southern-group-sgp.myshopify.com/cdn/shop/t/1/assets/arrow-left.svg" class="img-fluid" alt=""></a>',
        });
        checkAlsoLike = true;
      }
    }
    initializeRecommendationSlider();
    setInterval(initializeRecommendationSlider, 100);
  }

  if ($(window).innerWidth() <= 767) {
    $(".footer__item-title").click(function () {
      $(this).toggleClass("active");
      $(this).next().slideToggle(300);
    });

    $(".view-text-all a").click(function () {
      $(".product-desc__text").addClass("active");
      $(".view-text-all").slideUp(300);
    });
  }
  if ($(window).innerWidth() <= 1023) {
    $(".list-menu__item").click(function () {
      $(this).toggleClass("active");
      $(this).next().slideToggle(300);
    });

    $(".header__btn").click(function () {
      $(this).toggleClass("active");
      $(".header__center").toggleClass("active");
    });
  }
});
